<epay-page-content [pagetitle]="pagetitle">
  <epay-lib-common-changepassword
    [baseurl]="baseurl">
  </epay-lib-common-changepassword>
</epay-page-content>
